import { useEffect, useState } from 'react';
import { getPage } from '@/services/about/about.service';
import type { AboutPage } from '@edwin-group/people-graphql';
import DefaultContentTemplatePage from '../default-content-template';

const AboutPage = () => {
  const [page, setPage] = useState<AboutPage | null>(null);

  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    (async () => {
      setLoading(true);

      const pageResponse = await getPage();

      setPage(pageResponse.page);
      setLoading(false);
    })();
  }, []);

  const template = page?.DefaultContentTemplate || null;

  if (loading) {
    return null;
  }

  return (
    <>
      <DefaultContentTemplatePage template={template} title={page?.pageTitle || 'Back to the Homepage'} />
    </>
  );
};

export default AboutPage;
